import { useEffect } from 'react';

export const useGoogleTagManager = (appId: string) => {
  const containerId = "GTM-MC7C9WLN";
  const nblocksAppId = "606b3215efbe6b0008aee09d";
  const isEnabled = nblocksAppId === appId;  

  useEffect(() => {
    if (!isEnabled || !containerId) return;

    // Check if GTM is already initialized
    if (document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${containerId}"]`)) {
      return; // GTM already exists, don't add it again
    }

    // Create and inject GTM script
    const script = document.createElement('script');
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${containerId}');
    `;
    document.head.appendChild(script);

    // Check if noscript iframe already exists
    if (!document.querySelector(`iframe[src*="googletagmanager.com/ns.html?id=${containerId}"]`)) {
      const noscriptIframe = document.createElement('iframe');
      noscriptIframe.src = `https://www.googletagmanager.com/ns.html?id=${containerId}`;
      noscriptIframe.height = '0';
      noscriptIframe.width = '0';
      noscriptIframe.style.display = 'none';
      noscriptIframe.style.visibility = 'hidden';

      const noscript = document.createElement('noscript');
      noscript.appendChild(noscriptIframe);
      document.body.insertBefore(noscript, document.body.firstChild);
    }

    return () => {
      // We'll skip cleanup since we want GTM to persist
      // If we remove it, it might cause issues with tracking
    };
  }, [containerId, isEnabled]);
}; 